import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import UrlGenerator from './UrlGenerator';
var propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  routes: PropTypes.objectOf(PropTypes.string),
  getRoutes: PropTypes.func,

  /* eslint-enable react/no-unused-prop-types */
  children: PropTypes.node
};
var defaultProps = {
  routes: {},
  getRoutes: null,
  children: null
};
var childContextTypes = {
  urlGenerator: PropTypes.instanceOf(UrlGenerator)
};

var UrlGeneratorContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(UrlGeneratorContainer, _Component);

  function UrlGeneratorContainer(props) {
    var _this;

    _classCallCheck(this, UrlGeneratorContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UrlGeneratorContainer).call(this, props));
    _this.state = {
      urlGenerator: new UrlGenerator(_this.getRoutes())
    };
    return _this;
  }

  _createClass(UrlGeneratorContainer, [{
    key: "getChildContext",
    value: function getChildContext() {
      var urlGenerator = this.state.urlGenerator;
      return {
        urlGenerator: urlGenerator
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextRoutes = this.getRoutes(nextProps);
      var routes = this.getRoutes();

      if (!isEqual(nextRoutes, routes)) {
        this.setState({
          urlGenerator: new UrlGenerator(nextRoutes)
        });
      }
    }
  }, {
    key: "getRoutes",
    value: function getRoutes(props) {
      var _ref = props || this.props,
          getRoutes = _ref.getRoutes,
          routes = _ref.routes;

      return getRoutes !== null ? getRoutes() : routes;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);

  return UrlGeneratorContainer;
}(Component);

UrlGeneratorContainer.propTypes = propTypes;
UrlGeneratorContainer.defaultProps = defaultProps;
UrlGeneratorContainer.childContextTypes = childContextTypes;
export default UrlGeneratorContainer;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/UrlGeneratorContainer.js
// module id = null
// module chunks = 